import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import './index.css';
import { useHistory } from 'react-router-dom';

const LandingPageHead = () => {
  let history = useHistory();
  return (
    <div className="container-bg-head">
      <Container>
        <Row className="pt-5">
          <Col md={{ span: 12 }}>
            <div className="d-flex flex-column">
              <div className="text-center title-head">
                ECLIPSE SOFTWARE PROJECTS
              </div>
              <div className="text-center subtitle-head">
                A Website for show off your project
              </div>
              <div className="d-flex justify-content-center">
                <button
                  type="button"
                  className="btn btn-dark my-5 explore-btn"
                  onClick={() => {
                    history.push('/project');
                  }}
                >
                  Explore Projects
                </button>
              </div>
              <div className="d-flex justify-content-center">
                <p className="dots"></p>
                <p className="dots"></p>
                <p className="dots"></p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default LandingPageHead;
